import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SelectLocation from "../dropdown";
import { Link } from "react-router-dom";
import axios from "../../API/axios";
import FormContent from "./FormContent";
import ReactSelect from "react-select";
import { customStyles } from "../../selectStyles";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import bannnerimg from "../../assets/images/bannerimg.jpeg"


Banner07.propTypes = {};


function Banner07(props) {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [searchUserName, setSearchUserName] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const candidateIdParam = params.get("Candidate") || "";
    setSearchUserName(candidateIdParam);

  }, [dispatch, location.search]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!searchUserName) {
      toast.error("Search candidate");
      return;
    }

    const queryParams = new URLSearchParams();
    if (searchUserName) queryParams.set("Candidate", searchUserName);

    navigate(`/Candidate/All?${queryParams.toString()}`);
  };

  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [userList, setUserList] = useState([]);
  const [searchuserList, setSearchuserList] = useState([]);

  const [isError, setIsError] = useState(false);
  const [nextBatchLoading, setNextBatchLoading] = useState("");


  // const getAllUserList = (page) => {
  //   setNextBatchLoading(true);
  //   const data = {
  //     pageNumber: page,
  //     pageSize: 20,
  //   };

  //   axios
  //     .post(`/Candidate/GetAll?Search=${searchUserName}`, data)
  //     .then((response) => {
  //       const res = response.data.responseData.candidateProfiles;
  //       setUserList(res);
  //       setIsLoading(false);
  //       setTotalPages(response.data.responseData.paging.totalPages);

  //       const newPosts = response.data.responseData.candidateProfiles;
  //       console.log("newwwwposttt", newPosts);

  //       if (searchUserName !== "") {
  //         setUserList([]);
  //         setSearchuserList(newPosts);
  //       } else {
  //         setSearchuserList([]);
  //         setUserList((prev) => {
  //           const userSet = new Set(prev?.map((user) => user?.uid));
  //           const uniqueNewPosts = newPosts.filter(
  //             (user) => !userSet.has(user?.uid)
  //           );
  //           return [...prev, ...uniqueNewPosts];
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       if (error.response && error.response.status === 404) {
  //         setIsError(true);
  //       } else {
  //         console.log(error);
  //       }
  //       setIsLoading(false);
  //       setNextBatchLoading(false);
  //     });
  // };

  // useEffect(() => {
  //   if (page <= totalPages) {
  //     getAllUserList(page + 1);
  //   }

  //   if (searchUserName) {
  //     setUserList([]);
  //     getAllUserList(1, searchUserName);
  //   }
  // }, [page, searchUserName]);


  return (

    <section className="tf-slider sl5  parallax">
      <div className="content"></div>
      <div className="container ">
        <div className="row ">
          <div className="col-lg-12">
            <div className="content formContent mobile-dropdown mobile-city-syle pt-4 text-center m-auto banners-mobile-search" style={{ width: '70%' }}>
              <h2 className="text-dark f-600 mb-3">Navigate the Path to Possibilities</h2>
              <p className="text-dark mb-4">Step into a career that aligns with your purpose. Khoj bridges the gap between your potential and the right opportunities—connecting you to roles that align with your goals and inspire you to achieve more.</p>
              <div className="form-sl">
                <form onSubmit={handleSubmit}>
                  <div className="row-group-search home1 st">
                    <div className="form-group-1 col-8" style={{maxWidth:"580px"}}>
                      <input
                        type="text"
                        className="input-filter-search"
                        id="exampleInputEmail1"
                        placeholder="Search Candidates"
                        onChange={(e) => {
                          setSearchUserName(e.target.value);
                          // getAllUserList();
                        }}
                        value={searchUserName}
                      />
                    </div>
                    {/* <div className="form-group-2 col-4">
                      <span className="icon-map-pin"></span>
                      <SelectLocation />
                    </div> */}
                    <div className="form-group-4 row-search-group-button">
                      <button type="submit" className="btn khojPrimaryBtn" style={{ width: '150px', height: '50px', display: "flex" }}>

                        Search
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="overlay"></div>
    </section>
  );
}

export default Banner07;
